// extracted by mini-css-extract-plugin
module.exports = {"icon-avatar":"icon-avatar__icon-avatar___1lAV-"};